module.exports = __webpack_public_path__ + "static/media/user-list.011cef22.png";